import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationsCountsKey,
  employerApplicationsKey,
  errorMessage,
  interviewActionRoute,
  interviewCountsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useUpdateInterviewActionProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useUpdateInterviewAction = ({
  setErrorText,
}: useUpdateInterviewActionProps) => {
  const client = useQueryClient();

  const {
    mutate: updateInterviewAction,
    isLoading: isUpdateInterviewActionLoading,
  } = useMutation({
    mutationFn: (variables: {
      application_id: number;
      interview_action: "" | "completed" | "missed";
    }) =>
      axiosInstance
        .post(interviewActionRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(interviewCountsKey);
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    updateInterviewAction,
    isUpdateInterviewActionLoading,
  };
};
